import { render } from "./PrivacyPolicy.html?vue&type=template&id=156722b2&scoped=true&external"
import script from "./PrivacyPolicy.js?vue&type=script&lang=javascript&external"
export * from "./PrivacyPolicy.js?vue&type=script&lang=javascript&external"

import "./PrivacyPolicy.scss?vue&type=style&index=0&id=156722b2&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-156722b2"]])

export default __exports__